// extracted by mini-css-extract-plugin
module.exports = {"container":"CreditBanner_container__JMpuB"};